import { allLng, defaultLng } from "./configs";

export function validateEmail(email) {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function getOrSetLng() {
  let localLng = localStorage.getItem("lng");
  if (localLng) {
    if (!allLng.includes(localLng)) {
      localStorage.setItem("lng", defaultLng);
      localLng = defaultLng;
    }
  } else {
    localStorage.setItem("lng", defaultLng);
    localLng = defaultLng;
  }
  return localLng;
}

export function lngToString(lng) {
  let stringToReturn = "";
  switch (lng) {
    default:
    case "fr": {
      stringToReturn = "Français";
      break;
    }
    case "it": {
      stringToReturn = "Italien";
      break;
    }
    case "de": {
      stringToReturn = "Allemand";
      break;
    }
  }
  return stringToReturn;
}

export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

function filterDataByStatus(periods, filterStatus) {
  let toReturn = [];
  if (filterStatus) {
    if (filterStatus === null) {
      toReturn = periods;
    } else {
      periods.map((Period) => {
        let newPeriod = JSON.parse(JSON.stringify(Period));
        let newPeriodActivities = [];
        Period.activities.map((Activity) => {
          if (Activity.status === null && filterStatus === "selection") {
            return newPeriodActivities.push(Activity);
          }
          if (Activity.status === filterStatus) {
            return newPeriodActivities.push(Activity);
          } else return false;
        });
        newPeriod.activities = newPeriodActivities;
        return toReturn.push(newPeriod);
      });
    }
  } else {
    toReturn = periods;
  }
  return toReturn;
}

export function periodsFilter(periods, selectedYear, selectedStatus) {
  let periodsToReturn = filterDataByStatus(periods, selectedStatus);
  periodsToReturn = periodsToReturn.filter((Period) => {
    let periodStart = Period.start.substring(0, 4);
    return periodStart === selectedYear;
  });
  return periodsToReturn;
}

export function getNbrSelectedProducts(products) {
  let toReturn = 0;
  products.map((Product) => {
    return (toReturn = Product.selected_by_pharmacy ? toReturn + 1 : toReturn);
  });
  return toReturn;
}

export function timeSince(date) {
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
}

// Taille maximale acceptee par l'API (mimes:jpeg,jpg,png,gif|max:10240)
export const MAX_UPLOAD_SIZE = 10240 * 1024;
// Marge sous le post_max_size de PHP (50M) pour l'envoi groupe des photos produits :
// jusqu'a 20 fichiers plus les champs du formulaire et l'entete multipart
export const MAX_UPLOAD_TOTAL_SIZE = 40 * 1024 * 1024;
// Cote le plus long conserve apres compression, et qualite JPEG
const MAX_PICTURE_SIDE = 2000;
const PICTURE_QUALITY = 0.8;
// En dessous de ce seuil on n'essaie meme pas de compresser
const COMPRESSION_THRESHOLD = 1024 * 1024;

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("decode failed"));
    };
    image.src = url;
  });
}

/**
 * Redimensionne et recompresse une photo avant l'envoi.
 * Les photos de smartphone font couramment 10 a 15 Mo, ce qui depasse les
 * limites de l'API (422) et de PHP (413) et fait echouer les uploads mobiles (408).
 * Retourne toujours un File : en cas d'echec de la compression (format non
 * decodable par le navigateur, canvas indisponible), l'original est renvoye tel quel.
 */
export async function compressImage(file) {
  if (!file || !file.type) return file;
  // Les GIF (potentiellement animes) et les formats exotiques passent tels quels
  if (file.type !== "image/jpeg" && file.type !== "image/png") return file;

  try {
    const image = await loadImage(file);
    const ratio = Math.min(
      1,
      MAX_PICTURE_SIDE / Math.max(image.width, image.height)
    );
    // Deja petite et legere : rien a gagner
    if (ratio === 1 && file.size < COMPRESSION_THRESHOLD) return file;

    const canvas = document.createElement("canvas");
    canvas.width = Math.round(image.width * ratio);
    canvas.height = Math.round(image.height * ratio);
    const context = canvas.getContext("2d");
    if (!context) return file;
    // drawImage applique l'orientation EXIF sur les navigateurs actuels
    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", PICTURE_QUALITY)
    );
    if (!blob || blob.size >= file.size) return file;

    const name = file.name.replace(/\.[^./\\]+$/, "") + ".jpg";
    return new File([blob], name, {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
  } catch (e) {
    return file;
  }
}

/**
 * Traduit une erreur d'upload en message affichable.
 * Sans cela le composant avalait l'erreur et la photo disparaissait sans explication.
 */
export function getUploadErrorMessage(error, t) {
  const translate = typeof t === "function" ? t : (message) => message;
  const status = error && error.response ? error.response.status : null;

  switch (status) {
    case 413:
    case 422:
      return translate(
        "La photo est trop lourde ou son format n'est pas accepté. Formats acceptés : JPG, PNG ou GIF, 10 Mo maximum."
      );
    case 401:
    case 419:
      return translate(
        "Votre session a expiré. Reconnectez-vous puis renvoyez la photo."
      );
    case 408:
      return translate(
        "L'envoi a été interrompu. Vérifiez votre connexion et réessayez."
      );
    default:
      if (!status) {
        return translate(
          "L'envoi a échoué : connexion interrompue. Vérifiez votre connexion et réessayez."
        );
      }
      return translate(
        "L'envoi de la photo a échoué. Réessayez ou contactez le support."
      );
  }
}
